import React, {useEffect, useState} from 'react';
import {GetType, GetUsers} from "../../services/users.service";
import {uploadToS3} from "../../utils/helpers";
import {Col, Form, Row} from "react-bootstrap";
import {FadeLoader} from "react-spinners";
import Select from "react-select";
import {useHistory} from "react-router-dom";
import {useFieldArray, useForm} from "react-hook-form";
import {CreatePost, GetPostById, UpdatePost} from "../../services/post.service";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {GetPodcastById} from "../../services/podcast.service";
import {UpdatePlan} from "../../services/plan.service";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import dayjs from 'dayjs';

function EditPost(props) {
    let history = useHistory();
    const [data, setData] = useState({});
    const [loader, setLoader] = useState(false);
    const [category, setCategory] = useState();
    const [type, setType] = useState();
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [images, setImages] = useState()
    const [isUpload, setIsUpload] = useState(false)
    const [isloading, setIsloading] = useState(false)
    const [file, setFile] = useState(null)
    const [dateTime, setDateTime] = useState()
    const [disable, setDisable] = useState(false)
    const [editSelectedUser, setEditSelectedUser] = useState();
    const {register, handleSubmit,control, setError,setValue, clearErrors,watch, formState: {errors}} = useForm({
        mode: "onBlur",
        defaultValues: {
            poll: [{ title: '' }]
        }
    });
    const { fields, append ,remove} = useFieldArray({
        control,
        name: 'poll'
    });
    const selectedType = watch('type');
    const selectedEventType = watch('event_type');

    useEffect(  async ()=>{
        let id = props.match.params.id;
        const endpoint = window.location.href;
        const hasViewSegment = endpoint.includes("view");
        if(hasViewSegment){
            setDisable(true)
        }else{
            setDisable(false)
        }
        await getCategory();
        await getType();
        await getUsers();
        await getPostByid(id);
    },[])

    const getPostByid = async (id) => {
        await GetPostById(id).then((result) => {
            if (result.status) {
                if (result.data) {
                    setData(result.data);
                    setValue("content", result.data?.content);
                    setValue("category", result.data?.category);
                    setValue("type", result.data?.type);
                    setValue("event_name", result.data?.event_name);
                    setValue("event_type", result.data?.event_type);
                    setValue("event_link", result.data?.event_link);
                    setDateTime(dayjs(result.data?.date_time));
                    setValue("status", (result.data?.status && result.data?.status == true ? "1":"0"));
                    setEditSelectedUser({ label:`${result.data?.author.full_name} (${result.data?.author.email})`, value: result.data?.author._id })
                    setSelectedUser(result.data?.author._id);

                    if (result.data?.attachments && result.data.attachments.length > 0) {
                        const imagePaths = result.data.attachments.map((attachment) => ({
                            url: attachment.path,
                            path: attachment.path,
                            type : attachment.mime_type
                        }));

                        setImages(imagePaths);
                        setIsUpload(true);
                    }


                    // Set dynamic poll fields based on result.data.polls length
                    result.data?.poll.map((field, index) => {
                        setValue(`title_${index}`, field?.title);
                      });

                    // Add additional poll fields if necessary
                    const initialPollFieldsCount = result.data?.poll.length;
                    const additionalPollFieldsCount = Math.max(0, initialPollFieldsCount - 1);
                    for (let i = 0; i < additionalPollFieldsCount; i++) {
                        append({ title: '' });
                    }

                }
            } else {
                return toast.error(result.message);
            }


        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })
    }

    const onSubmit = async data => {
        if(disable){
            history.goBack()
            return false
        }
        if(!selectedUser){
            setError('user' ,{message:"User is required"})
            return false
        }else{
            clearErrors('user')
        }
        if (images?.length === 0) {
            setError('media', { message: 'Please upload at least one image' });
            return false;
        }
        setLoader(true);

        const attachments = images?.map((image) => ({
            is_feature: true,
            mime_type: (image?.type.startsWith('image/') ? 'image' : 'video'),
            path: image?.path,
            type: 80,
        }));

        let id = props.match.params.id;
        let dt = {
            user_id:selectedUser,
            content: data.content || '-',
            category: data.category || '-',
            status: (data?.status && data?.status==1 ? true: false ),
            ...(data.type == "Event" ?{event_name: data.event_name} : {} ),
            ...(data.type == "Event" ?{event_type: data.event_type} : {} ),
            ...(data.type == "Event" ?{event_link: data.event_link} : {} ),
            ...(data.type == "Event" ?{date_time: dateTime} : {} ),
            type: data.type || '-',
            attachments: attachments,
            ...(data.type == "Post" ?{
                 poll: (data.type === 'Post' ? [] : fields.map((field, index) => ({
                title: data[`title_${index}`],
            })))}:{}),

        }

        await UpdatePost(id, dt).then(async (data) => {
            setLoader(false)
            if (data.status) {

                toast.success(data.message);
                history.push('/posts');
            } else {
                setLoader(false)
                toast.error(data.message);
            }
        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })

    };





    const getType = async () => {
        await GetType("PostTypes").then((result) => {
            if (result.status && result.data) {
                const PostTypes =  result.data[0].PostTypes;
                setType(Object.values(PostTypes));
            }
        })
    }

    const getCategory = async () => {
        await GetType("PostCategory").then((result) => {
            if (result.status && result.data) {
                const PostCategory =  result.data[0].PostCategory;
                setCategory(Object.values(PostCategory));
            }
        })
    }

    const getUsers = async () => {
        await GetUsers(false, 'User', null,null,null, null, 0).then((result) => {
            if (result.status && result.data) {
                setUsers(result.data);
            }
        })
    }


    const optionsUsers = (item) => {
        setSelectedUser(item.value);
        setEditSelectedUser({ label:item.label, value:item.value })
        if(!item.value){
            setError('user' ,{message:"User is required"})
        }else{
            clearErrors('user')
        }
    }


    const addPollField = () => {
        append({ meal: '', meal_date: '' });
    };

    const removePollField = () => {
        remove(fields.length - 1);
    };

    const uploadFiles = async (fileInput) => {
        const uploadedImages = [];
        setIsloading(true)
        for (let i = 0; i < fileInput.length; i++) {
            const file = fileInput[i];
            if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
                setError('media', { message: 'Invalid file type' });
                setIsloading(false);
                return false;
            }
            setIsloading(true)
            let fileUrl = URL.createObjectURL(file);
            const uploadedImage = await uploadToS3(file.type, file.name, file, 'podcast');
            if (uploadedImage) {
                uploadedImages.push({ url: fileUrl, path: uploadedImage ,type:file.type });
            }
        }
        setIsloading(false)
        setImages(uploadedImages);
        setIsUpload(true);
        if (uploadedImages.length > 0) {
            clearErrors('media');
        }
    };



    return (
        <div className="AddNewPost">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">{disable ? "View Post": "Edit Post"}</h3>
            <hr/>
            <Row>
                <Col xs={12} sm={12} md={10} lg={12} xl={6}>
                    <Form className="formAddUser" autoComplete="off" role="presentation"
                          onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="image">
                                    <Form.Label>Image* <Form.Text className=" text-muted" style={{fontSize:".675em"}}>(Max upload file size: 5 GB)</Form.Text> </Form.Label>
                                    <input
                                        {...register('media')}
                                        onChange={(e) => uploadFiles(e.target.files)}
                                        type='file'
                                        accept={'.jepg,.jpg,.png'}
                                        class={disable ? "disabled-file-input":"custom-file-input"}
                                        disabled={disable}
                                        id='image'
                                        multiple
                                    />

                                    {errors.media && <Form.Text
                                        className=" validationText hasError">{errors.media.message}</Form.Text>}
                                    <br/>
                                    {isloading ? (
                                        <div className="spin-loader">
                                            <FadeLoader color={"#41D2D2"} height={10} />
                                        </div>
                                    ) : (
                                        <>
                                            {isUpload && (
                                                <div className={'image-wrapper'}>
                                                    {images.map((image, index) => {
                                                        if (image.type.startsWith('image/') || image.type === 'image') {
                                                            return (
                                                                <img
                                                                    key={index}
                                                                    src={image.url}
                                                                    alt="uploaded"
                                                                    className="post-thumbnail mt-2"
                                                                    controls
                                                                    crossOrigin="anonymous"
                                                                />
                                                            );
                                                        } else if (image.type.startsWith('video/') || image.type === 'video') {
                                                            return (
                                                                <video
                                                                    key={index}
                                                                    src={image.url}
                                                                    className="post-thumbnail"
                                                                    type="video"
                                                                    controls
                                                                    crossOrigin="anonymous"
                                                                />
                                                            );
                                                        }
                                                        return null; // This handles other types like audio, etc.
                                                    })}
                                                </div>
                                            )}

                                        </>
                                    )}


                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="sports">
                                    <Form.Label className='d-block'>User*</Form.Label>
                                    <Select
                                        value={editSelectedUser}
                                        options={users && users?.map(e => ({ label:`${e.full_name} (${e.email})`, value:e._id }))}
                                        className="basic-multi-select"
                                        onChange={optionsUsers}
                                        isDisabled={disable}
                                    />
                                    {errors.user && <Form.Text className="text-muted validationText hasError">{errors.user.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className={"mb-3"} controlId="status">
                                    <Form.Label className='d-block'>Select Type*</Form.Label>
                                    <Form.Select className='formselect' aria-label="type"  disabled={true} {...register('type', {
                                        required: {
                                            value: "required",
                                            message: "Type is required"
                                        }
                                    })}>
                                        {type && type.map(value => (
                                            <option key={value} value={value}>{value}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.type && <Form.Text
                                        className=" validationText hasError">{errors.type.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            {selectedType === 'Event'?
                                <>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Group className="mb-3" controlId="event_name">
                                            <Form.Label>Event Name*</Form.Label>
                                            <Form.Control
                                                placeholder="Enter Event Name"
                                                id={"formSignUpName"}
                                                {...register('event_name', {
                                                    required: {
                                                        value: "required",
                                                        message: "Event Name is required"
                                                    },
                                                    pattern:{
                                                        value:/^(?!\s).*$/,
                                                        message:"Event Name should not start with a space"
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: "Min length is 3"
                                                    },
                                                    maxLength: {
                                                        value: 60,
                                                        message: "Max length is 60"
                                                    },
                                                })} type="text"
                                            />
                                            {errors.event_name && <Form.Text
                                                className="text-muted validationText hasError">{errors.event_name.message}</Form.Text>}

                                        </Form.Group>
                                    </Col>
                                    <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                        <Form.Group className={"mb-3"} controlId="status">
                                            <Form.Label className='d-block'>Select Event Type*</Form.Label>
                                            <Form.Select className='formselect' aria-label="type" {...register('event_type', {
                                                required: {
                                                    value: "required",
                                                    message: "Event Type is required"
                                                }
                                            })}>
                                                <option  value='' disabled hidden  selected>--Select--</option>
                                                <option  value='Online'>Online</option>
                                                <option  value='Physical'>Physical</option>
                                            </Form.Select>
                                            {errors.event_type && <Form.Text
                                                className=" validationText hasError">{errors.event_type.message}</Form.Text>}
                                        </Form.Group>
                                    </Col>
                                    <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                        <Form.Group className={"mb-3"} controlId="status">
                                            <Form.Label className='d-block'>Select Event Date & Time*</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DateTimePicker
                                                    // label="Controlled picker"
                                                    value={dateTime}
                                                    onChange={(newValue) => setDateTime(newValue)}
                                                />
                                            </LocalizationProvider>
                                            {errors.date_time && <Form.Text
                                                className=" validationText hasError">{errors.date_time.message}</Form.Text>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Group className="mb-3" controlId="event_link">
                                            <Form.Label>{selectedEventType === 'Online' ? "Event Link*":"Event Link"}</Form.Label>
                                            <Form.Control
                                                placeholder="Enter Event Link"
                                                id={"formSignUpName"}
                                                {...register('event_link', {
                                                    required: selectedEventType === 'Online' ? "Event Link is required" : false,
                                                    pattern:{
                                                        value:/^(?!\s).*$/,
                                                        message:"Event Link should not start with a space"
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: "Min length is 3"
                                                    },
                                                    maxLength: {
                                                        value: 300,
                                                        message: "Max length is 300"
                                                    },
                                                })} type="text"
                                            />
                                            {errors.event_link && <Form.Text
                                                className="text-muted validationText hasError">{errors.event_link.message}</Form.Text>}

                                        </Form.Group>
                                    </Col>
                                </> : null}
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="text">
                                    <Form.Label>{selectedType === 'Event'? "Description*" : "Content*"}</Form.Label>
                                    <textarea id='custom-text-area' rows={6} cols={55}
                                               placeholder={`Enter ${selectedType === 'Event'? "Description" : "Content"}`}
                                               {...register('content', {
                                                   required: {
                                                       value: "required",
                                                       message: `${selectedType === 'Event'? "Description" : "Content"} is required`
                                                   },
                                                   pattern:{
                                                       value: /^(?!\s)(?:[\s\S]*\S)?$/gm,
                                                       message:`${selectedType === 'Event'? "Description" : "Content"} should not start with a space`
                                                   },
                                                   minLength: {
                                                       value: 3,
                                                       message: "Min length is 3"
                                                   },
                                                   maxLength: {
                                                       value: 2000,
                                                       message: "Max length is 2000"
                                                   },
                                               })} type="text" />
                                    {errors.content && <Form.Text
                                        className=" validationText hasError">{errors.content.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className={"mb-3"} controlId="status">
                                    <Form.Label className='d-block'>Select Category*</Form.Label>
                                    <Form.Select className='formselect' aria-label="type"  disabled={disable} {...register('category', {
                                        required: {
                                            value: "required",
                                            message: "Category is required"
                                        }
                                    })}>
                                        {category && category.map(value => (
                                            <option key={value} value={value}>{value}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.category && <Form.Text
                                        className=" validationText hasError">{errors.category.message}</Form.Text>}
                                </Form.Group>
                            </Col>


                        </Row>
                        {selectedType === 'Poll' && (
                            <>
                                {fields.map((field, index) => (
                                    <Row key={field.id}>
                                        <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                            <Form.Group className="mb-3" controlId={`text${field.id}`}>
                                                <Form.Label>{`Poll Option${index === 0 ? '*' : ` ${index + 1}*`}`}</Form.Label>
                                                <Form.Control
                                                    disabled={true}
                                                    placeholder="Enter title"
                                                    {...register(`title_${index}`, {
                                                        required: {
                                                            value: true,
                                                            message: "Title is required",
                                                        },
                                                        pattern: {
                                                            value: /^(?!\s).*$/,
                                                            message: "Title should not start with a space",
                                                        },
                                                        minLength: {
                                                            value: 3,
                                                            message: "Min length is 3",
                                                        },
                                                        maxLength: {
                                                            value: 100,
                                                            message: "Max length is 100",
                                                        },
                                                    })}
                                                    type="text"
                                                />
                                                {errors?.[`title_${index}`] && (
                                                    <Form.Text className="validationText hasError">
                                                        {errors?.[`title_${index}`].message}
                                                    </Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                ))}
                                <Row>
                                    {!disable &&
                                        <>
                                            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                                                <button type="button" className="btn btn-green-theme w-60 mb-3" disabled={true} onClick={addPollField}>
                                                    Add Poll
                                                </button>
                                            </Col>

                                            {fields.length !== 1 && (
                                                <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                                                    <button type="button" className="btn btn-green-theme w-60 mb-3" disabled={true} onClick={removePollField}>
                                                        Remove Poll
                                                    </button>
                                                </Col>
                                            )}
                                        </>
                                     }


                                </Row>
                            </>
                        )}

                        <Row>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className={"mb-3"} controlId="status">
                                    <Form.Label className='d-block'>Select Status*</Form.Label>
                                    <Form.Select className='formselect' aria-label="status"  disabled={disable} {...register('status', {
                                        required: {
                                            value: "required",
                                            message: "Status is required"
                                        }
                                    })}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </Form.Select>
                                    {errors.status && <Form.Text
                                        className=" validationText hasError">{errors.status.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                {loader ? <div className="spin-loader">
                                        <FadeLoader color={"#41D2D2"} height={10}/>
                                    </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                           value={ disable ? "Back":"Update Post"}/>}
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

        </div>
    )
}

export default EditPost;